import {
  ProductTransferListResponseDto,
  ResultPaginationResponseDto,
} from '@tiendanube/common';
import { cirrusApi, infinityBehavior, tableBehavior } from 'App/rtk';
import { GenericParamsType } from 'commons/types';
import {
  TransfersEndpoints,
  TransfersTags,
  BASE_TRANSFERS_URL,
} from './settings';

export const transfersApi = cirrusApi
  .enhanceEndpoints({
    addTagTypes: [TransfersTags.transfers],
  })
  .injectEndpoints({
    endpoints: (builder) => ({
      [TransfersEndpoints.getTransfersList]: builder.query<
        ResultPaginationResponseDto<ProductTransferListResponseDto>,
        GenericParamsType
      >({
        query: (params) => ({
          method: 'GET',
          url: BASE_TRANSFERS_URL,
          params,
        }),
        providesTags: [TransfersTags.transfers],
        ...tableBehavior(TransfersEndpoints.getTransfersList),
      }),
      [TransfersEndpoints.getTransfersListInf]: builder.query<
        ResultPaginationResponseDto<ProductTransferListResponseDto>,
        GenericParamsType
      >({
        query: (params) => ({
          method: 'GET',
          url: BASE_TRANSFERS_URL,
          params,
        }),
        providesTags: [TransfersTags.transfers],
        ...infinityBehavior(TransfersEndpoints.getTransfersListInf),
      }),
    }),
  });

export const { useGetTransfersListQuery, useGetTransfersListInfQuery } =
  transfersApi;
